var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useRef, useContext, useCallback, useMemo, } from 'react';
import ButtonComponent from './ButtonComponent';
import '../styles/manipulativeTool.scss';
import globalStore from '../store';
import { useOnResize } from '../helper/hooks/onResize';
import FlipButton from './FlipButton';
import CustomScrollbar from './CustomScrollbar';
import { t } from 'i18next';
import { DataContext } from '../player/DataContext';
import { v4 as uuidv4 } from 'uuid';
import { saveState } from '../helper/stateManagerHelper';
import customEventHandler from '../helper/customEvents';
import { announce } from '../helper/announcer';
import { getImageSrc } from '../helper/imageBlobCache';
import { trackEvent, AnalyticsCategory } from '../helper/analytics';
// Reliable touch-primary detection — works on modern iPads (desktop UA)
var IS_TOUCH_DEVICE = typeof window !== 'undefined' && !!((_a = window.matchMedia) === null || _a === void 0 ? void 0 : _a.call(window, '(pointer: coarse)').matches);
var ManipulativeTool = function (props) {
    var _a, _b, _c, _d;
    var _e = props.className, className = _e === void 0 ? '' : _e;
    var _f = useContext(DataContext), manipulativeBtnState = _f.manipulativeBtnState, setManipulativeBtnState = _f.setManipulativeBtnState, setManiplulatorComponentVisible = _f.setManiplulatorComponentVisible, setActiveManipulator = _f.setActiveManipulator, maniplulatorComponentVisible = _f.maniplulatorComponentVisible, setManipulative = _f.setManipulative, manipulative = _f.manipulative, getPositionForNewItem = _f.getPositionForNewItem, selectedTool = _f.selectedTool, setSelectedTool = _f.setSelectedTool, setTablePopup = _f.setTablePopup, selectedManipulativeId = _f.selectedManipulativeId, setSelectedManipulativeId = _f.setSelectedManipulativeId;
    var _g = globalStore.useStoreState(function (state) { return state.playerStore; }), displayMode = _g.displayMode, zoomLevel = _g.zoomLevel, playerIconZoom = _g.playerIconZoom, isAdmin = _g.isAdmin, viewEditMode = _g.viewEditMode;
    var _h = globalStore.useStoreState(function (state) { return state.jsonDataStore; }), btnConfig = _h.btnConfig, manipulativeBtn = _h.mainConfig.manipulativeBtn;
    var _j = useState(), btnData = _j[0], setBtnData = _j[1];
    var _k = useState(false), openTool = _k[0], setOpenTool = _k[1];
    var scrollbarRef = useRef(null);
    var _l = useState({ flexDirection: 'column' }), pos = _l[0], setPos = _l[1];
    var buffer = displayMode !== 'normal' ? 30 : 20;
    var _m = useState(false), headerHovered = _m[0], setHeaderHovered = _m[1];
    var _o = useState([]), childOpenList = _o[0], setChildOpenList = _o[1];
    var _p = useState(''), announcement = _p[0], setAnnouncement = _p[1];
    var _q = useState({
        headerHeight: 0,
        zoomPanelHeight: 0,
    }), heightVal = _q[0], setHeighttVal = _q[1];
    useEffect(function () {
        var _a;
        var allItems = (_a = manipulativeBtn === null || manipulativeBtn === void 0 ? void 0 : manipulativeBtn.btnList) !== null && _a !== void 0 ? _a : [];
        // null = no saved state → no tools configured, show nothing
        var filteredList = manipulativeBtnState === null
            ? []
            : allItems
                .map(function (item) {
                if (item.childList) {
                    var filteredChildren = item.childList.filter(function (child) { var _a; return manipulativeBtnState[(_a = child.id) !== null && _a !== void 0 ? _a : '']; });
                    return __assign(__assign({}, item), { childList: filteredChildren });
                }
                return item;
            })
                .filter(function (item) {
                var _a;
                return manipulativeBtnState[(_a = item.id) !== null && _a !== void 0 ? _a : ''] || (item.childList && item.childList.length > 0);
            });
        var newBtnData = isAdmin && viewEditMode === 'edit' ? allItems : filteredList;
        setBtnData(newBtnData);
        setChildOpenList(function (prev) {
            if (prev.length === newBtnData.length)
                return prev;
            return newBtnData.map(function () { return false; });
        });
    }, [manipulativeBtnState, viewEditMode]);
    var onUpdateUI = function () {
        if (displayMode === 'normal') {
            setTimeout(function () {
                var _a;
                var zoomAndPanControlPanel = document.querySelector('#zoomAndPanControlPanel');
                var header = document.querySelector('.appHeader');
                var btnWithHeading = document.getElementsByClassName('btnWithHeading')[0];
                if (header && zoomAndPanControlPanel) {
                    setHeighttVal({
                        headerHeight: header.offsetHeight + buffer + buffer + ((_a = btnWithHeading === null || btnWithHeading === void 0 ? void 0 : btnWithHeading.clientHeight) !== null && _a !== void 0 ? _a : 0),
                        zoomPanelHeight: (zoomAndPanControlPanel === null || zoomAndPanControlPanel === void 0 ? void 0 : zoomAndPanControlPanel.offsetHeight) + 26,
                    });
                    // setHeighttVal(min(100vh -))
                    var rect = header.getBoundingClientRect();
                    setPos({
                        top: rect.height + buffer,
                        bottom: 'unset',
                        right: 30,
                        flexDirection: 'column',
                    });
                }
            }, 0);
        }
        else {
            setTimeout(function () {
                var _a;
                var zoomAndPanControlPanel = document.querySelector('#zoomAndPanControlPanel');
                var footer = document.querySelector('.footer');
                var btnWithHeadingAlt = document.getElementsByClassName('btnWithHeading')[0];
                if (footer) {
                    var rect = footer.getBoundingClientRect();
                    console.log(zoomAndPanControlPanel, footer, 'zoomAndPanControlPanel');
                    setHeighttVal({
                        headerHeight: 26 + (zoomAndPanControlPanel === null || zoomAndPanControlPanel === void 0 ? void 0 : zoomAndPanControlPanel.offsetHeight) + 15,
                        zoomPanelHeight: footer.offsetHeight + buffer + ((_a = btnWithHeadingAlt === null || btnWithHeadingAlt === void 0 ? void 0 : btnWithHeadingAlt.clientHeight) !== null && _a !== void 0 ? _a : 0),
                    });
                    setPos({
                        bottom: rect.height + buffer - 10,
                        top: 'unset',
                        right: 30,
                        flexDirection: 'column-reverse',
                    });
                }
            }, 0);
        }
    };
    useEffect(function () {
        onUpdateUI();
    }, [displayMode, zoomLevel, playerIconZoom]);
    var handleResize = useCallback(function () {
        onUpdateUI();
    }, [displayMode, zoomLevel, playerIconZoom]);
    useOnResize(handleResize);
    var childBtnClick = function (index, item) {
        // "Coming soon" entries (e.g. numberLines) render but never trigger any
        // action. Bail before any side-effects. Click / Enter / Space all funnel
        // through this handler, so a single guard covers every entry path.
        if (item.disabled)
            return;
        if (item.type) {
            setChildOpenList(function (prev) {
                var next = __spreadArray([], prev, true);
                next[index] = !next[index];
                return next;
            });
        }
        else {
            setOpenTool(false);
            // Track which math tool a user opens. `item.id` is the tool's stable
            // identifier (dice, protractor, clocks, …).
            if (item.id)
                trackEvent(AnalyticsCategory.mathTool, 'open', item.id);
            switch (item.id) {
                case 'dice':
                    setManiplulatorComponentVisible(true);
                    setActiveManipulator(item.id);
                    console.log(item.id, 'checking item.id');
                    break;
                case 'spinners':
                    setManiplulatorComponentVisible(true);
                    setActiveManipulator(item.id);
                    break;
                case 'numberCharts':
                    setManiplulatorComponentVisible(true);
                    setActiveManipulator(item.id);
                    break;
                case 'cards':
                    setManiplulatorComponentVisible(true);
                    setActiveManipulator(item.id);
                    break;
                case 'clocks':
                    setManiplulatorComponentVisible(true);
                    setActiveManipulator(item.id);
                    break;
                case 'linkingCubes': {
                    var existingLinkingCube = manipulative.find(function (m) { return m.data.type === 'linkingCubes'; });
                    if (existingLinkingCube && existingLinkingCube.data.id) {
                        setSelectedTool([existingLinkingCube.data.id]);
                    }
                    else {
                        // No cubes yet — just open the toolbar for dragging
                        setSelectedTool(['linkingCubes_dummyForRightTool']);
                    }
                    // A11y: move focus into the right drawer after it opens so keyboard/SR
                    // users aren't stranded in the math tools list.
                    setTimeout(function () {
                        var panel = document.querySelector('.rightSideToolPanel');
                        var firstFocusable = panel === null || panel === void 0 ? void 0 : panel.querySelector('button:not([disabled]), [tabindex]:not([tabindex="-1"]), input:not([disabled])');
                        firstFocusable === null || firstFocusable === void 0 ? void 0 : firstFocusable.focus();
                    }, 150);
                    break;
                }
                case 'numberFrames': {
                    // No frame is created directly — set a dummy so the right panel shows the "Add Frame" button
                    var dummyId = "numberFrame_".concat(uuidv4().replace(/-/g, ''), "_dummyForRightTool");
                    setSelectedTool([dummyId]);
                    // Move keyboard/screen-reader focus to the top token-setting-btn once
                    // the right-side panel renders. Without this, focus is left on the
                    // now-inert manipulative dropdown button and drops to <body>.
                    setTimeout(function () {
                        var btn = document.querySelector('.tokenSettingBtnWrapper.token-setting-top .token-setting-btn');
                        if (btn)
                            btn.focus();
                    }, 100);
                    break;
                }
                case 'patternShapes':
                    // Open right sidebar for pattern shapes controls (do not auto-create manipulative)
                    setSelectedTool(["patternShapes_dummyForRightTool"]);
                    // Ensure manipulator panel doesn't auto-create the widget
                    setManiplulatorComponentVisible(false);
                    break;
                case 'arrayModels':
                case 'coloredTiles':
                    setManiplulatorComponentVisible(true);
                    setActiveManipulator(item.id);
                    break;
                case 'coinsAndCounters':
                    // Open ONLY the configuration popup. The right-side drawer stays
                    // hidden until the user clicks Done (popup's onAction handler
                    // sets selectedTool to the dummy then) — this matches the user's
                    // requested flow: pick counters first, drawer appears after.
                    // For Configure on a placed counter (CoinsAndCountersManipulative
                    // bottomPanel listener), selectedTool is already the counter's
                    // id, so the drawer remains visible during that flow.
                    setManiplulatorComponentVisible(true);
                    setActiveManipulator(item.id);
                    break;
                case 'table':
                    setTablePopup(true);
                    break;
                case 'protractor':
                    var _a = getPositionForNewItem(), x = _a.x, y = _a.y;
                    var newProtractorId = "protractor_".concat(uuidv4().replace(/-/g, ''));
                    var newProtractor_1 = {
                        type: 'protractor',
                        data: {
                            id: newProtractorId,
                            type: 'protractor',
                            center: { x: x, y: y },
                            dimensions: { width: 562, height: 562 },
                            scale: 1,
                            rotation: 0,
                            armAngle: -120,
                            lock: { positioning: false, editing: false },
                            isGroup: false,
                        },
                    };
                    saveState({
                        type: newProtractorId,
                        id: newProtractorId.split('_')[1],
                        propertyName: 'create',
                        old: JSON.stringify(newProtractor_1),
                    });
                    setManipulative(function (prev) { return __spreadArray(__spreadArray([], prev, true), [newProtractor_1], false); });
                    // Auto-select the newly created protractor
                    setSelectedTool([newProtractorId]);
                    break;
                case 'numberRacks': {
                    var _b = getPositionForNewItem(), rackX = _b.x, rackY = _b.y;
                    var newRackId_1 = "numberRacks_".concat(uuidv4().replace(/-/g, ''));
                    var newRack_1 = {
                        type: 'numberRacks',
                        data: {
                            id: newRackId_1,
                            type: 'numberRacks',
                            dimensions: { width: 894, height: 256 },
                            center: { x: rackX, y: rackY },
                            scale: 1,
                            lock: {
                                positioning: false,
                                editing: false,
                            },
                            rods: [
                                {
                                    id: "rod_".concat(uuidv4().replace(/-/g, '')),
                                    type: 'rod',
                                    data: {
                                        beads: [0, 0, 0, 0, 0, 1, 1, 1, 1, 1],
                                        beadsRawPosition: [
                                            476.2, 515.6, 555.0, 594.4, 633.8, 673.2, 712.6, 752.0, 791.4, 830.8,
                                        ],
                                        isReversed: false,
                                    },
                                },
                                {
                                    id: "rod_".concat(uuidv4().replace(/-/g, '')),
                                    type: 'rod',
                                    data: {
                                        beads: [0, 0, 0, 0, 0, 1, 1, 1, 1, 1],
                                        beadsRawPosition: [
                                            476.2, 515.6, 555.0, 594.4, 633.8, 673.2, 712.6, 752.0, 791.4, 830.8,
                                        ],
                                        isReversed: false,
                                    },
                                },
                            ],
                        },
                        widgetId: "numberRacks:".concat(uuidv4().replace(/-/g, '')),
                    };
                    saveState({
                        type: newRackId_1,
                        id: newRackId_1.split('_')[1],
                        propertyName: 'create',
                        old: JSON.stringify(newRack_1),
                    });
                    setManipulative(function (prev) { return __spreadArray(__spreadArray([], prev, true), [newRack_1], false); });
                    setSelectedTool([newRackId_1]);
                    announce("".concat(t('text.numberRackCreated', { rows: 2, red: 5, white: 5 }), " ") +
                        "".concat(t('text.numberRackAllResting'), " ") +
                        t('text.atPosition', { x: Math.round(rackX), y: Math.round(rackY) }));
                    // Move keyboard focus to the newly added number rack
                    setTimeout(function () {
                        var el = document.querySelector("[data-manipulative-id=\"".concat(newRackId_1, "\"]"));
                        if (el)
                            el.focus();
                    }, 100);
                    break;
                }
                case 'fractionTiles':
                    var isSomeFractionTileSelected = selectedTool.filter(function (item) { return item.startsWith('fractionTiles_'); }).length > 0;
                    if (isSomeFractionTileSelected) {
                        setSelectedTool(selectedTool.filter(function (item) { return !item.startsWith('fractionTiles_'); }));
                    }
                    if (selectedManipulativeId) {
                        setSelectedTool(selectedTool.filter(function (item) { return item !== selectedManipulativeId; }));
                        setSelectedManipulativeId('');
                    }
                    setManiplulatorComponentVisible(true);
                    setActiveManipulator(item.id);
                    break;
                case 'numberLines':
                    setManiplulatorComponentVisible(true);
                    setActiveManipulator('numberLines');
                    break;
                case 'counters':
                    setManiplulatorComponentVisible(true);
                    setActiveManipulator(item.id);
                    break;
                case 'moneyPieces':
                    setManiplulatorComponentVisible(true);
                    setActiveManipulator(item.id);
                    break;
                default:
                    break;
            }
        }
    };
    // const clickHandler = (item: string) => {
    //   setManiplulatorComponentVisible(true);
    //   setActiveManiplutator(item);
    // };
    var manageState = function (item) {
        var _a, _b;
        var key = (_a = item.id) !== null && _a !== void 0 ? _a : '';
        // `true` = visible to students, `false` = hidden. A teacher toggling a
        // manipulative off is the "hiding manipulatives" action we want to track.
        var nextVisible = !((_b = (manipulativeBtnState !== null && manipulativeBtnState !== void 0 ? manipulativeBtnState : {})[key]) !== null && _b !== void 0 ? _b : false);
        trackEvent(AnalyticsCategory.manipulative, nextVisible ? 'show' : 'hide', key);
        setManipulativeBtnState(function (prev) {
            var _a;
            return (__assign(__assign({}, (prev !== null && prev !== void 0 ? prev : {})), (_a = {}, _a[key] = nextVisible, _a)));
        });
    };
    var flatNavItems = useMemo(function () {
        if (!btnData)
            return [];
        var items = [];
        btnData.forEach(function (item, rootIdx) {
            items.push({
                type: 'root',
                rootIndex: rootIdx,
                item: item,
                isGroup: !!(item.childList && item.childList.length > 0),
            });
            if (item.childList && childOpenList[rootIdx]) {
                item.childList.forEach(function (child, childIdx) {
                    items.push({
                        type: 'child',
                        rootIndex: rootIdx,
                        childIndex: childIdx,
                        item: child,
                        isGroup: false,
                    });
                });
            }
        });
        return items;
    }, [btnData, childOpenList]);
    var _r = useState(0), activeNavIndex = _r[0], setActiveNavIndex = _r[1];
    var itemRefs = useRef(new Map());
    // ─── Action mode: Enter on an item focuses its action buttons ───
    var _s = useState(false), inActionMode = _s[0], setInActionMode = _s[1];
    var _t = useState(0), actionBtnIndex = _t[0], setActionBtnIndex = _t[1];
    // Ref to avoid stale closure in keydown/focus handlers
    var inActionModeRef = useRef(false);
    useEffect(function () {
        inActionModeRef.current = inActionMode;
    }, [inActionMode]);
    // When panel opens: focus first menuitem so arrow keys route through handleListKeyDown.
    // When panel closes: reset action mode.
    useEffect(function () {
        if (openTool) {
            // Invariant: menu opens at the top with every group collapsed. Centralised
            // here so all close paths (toggle, Escape, leaf pick in childBtnClick) get
            // a consistent open state without each having to remember to reset.
            setChildOpenList(function (prev) { return prev.map(function () { return false; }); });
            setActiveNavIndex(0);
            setInActionMode(false);
            inActionModeRef.current = false;
            setActionBtnIndex(0);
            // Firefox needs the scroll reset AFTER the .verticalList height transition
            // has begun laying out; setting it synchronously while the container is
            // still height:0 is not persisted reliably. preventScroll on focus blocks
            // Firefox's implicit scrollIntoView on focus-in, which otherwise re-scrolls
            // the list after our reset.
            requestAnimationFrame(function () {
                var _a;
                if (!IS_TOUCH_DEVICE) {
                    var el = itemRefs.current.get(0);
                    if (el)
                        el.focus({ preventScroll: true });
                }
                (_a = scrollbarRef.current) === null || _a === void 0 ? void 0 : _a.scrollToTop();
            });
        }
        else {
            setInActionMode(false);
            inActionModeRef.current = false;
        }
    }, [openTool]);
    // Clamp active index when list changes
    useEffect(function () {
        if (activeNavIndex >= flatNavItems.length) {
            setActiveNavIndex(Math.max(0, flatNavItems.length - 1));
        }
    }, [flatNavItems.length]);
    // Get action buttons for current item (Add button + Show/Hide button)
    var getActionButtons = useCallback(function (navIndex) {
        var el = itemRefs.current.get(navIndex);
        if (!el)
            return [];
        var buttons = [];
        // Add/Open button (manipulativeBtn)
        var addBtn = el.querySelector('button.manipulativeBtn');
        if (addBtn)
            buttons.push(addBtn);
        // Show/Hide button (eyeBtn) — only in admin edit mode
        var eyeBtn = el.querySelector('button.eyeBtn');
        if (eyeBtn)
            buttons.push(eyeBtn);
        return buttons;
    }, []);
    // Focus the active action button when action mode state changes
    useEffect(function () {
        if (inActionMode) {
            var buttons = getActionButtons(activeNavIndex);
            if (buttons[actionBtnIndex]) {
                buttons[actionBtnIndex].focus();
            }
        }
    }, [inActionMode, actionBtnIndex, activeNavIndex, getActionButtons]);
    var focusNavItem = useCallback(function (index) {
        setActiveNavIndex(index);
        setInActionMode(false);
        inActionModeRef.current = false;
        setActionBtnIndex(0);
        requestAnimationFrame(function () {
            var el = itemRefs.current.get(index);
            if (el) {
                // Focus the menuitem div itself (not the button inside)
                el.focus();
            }
        });
    }, []);
    // Timestamp when action mode was entered — block Enter/Space within 300ms
    var actionModeEnteredAt = useRef(0);
    var enterActionMode = useCallback(function (navIndex, btnIdx) {
        if (btnIdx === void 0) { btnIdx = 0; }
        setInActionMode(true);
        inActionModeRef.current = true;
        actionModeEnteredAt.current = Date.now();
        setActionBtnIndex(btnIdx);
    }, []);
    var exitActionMode = useCallback(function () {
        setInActionMode(false);
        inActionModeRef.current = false;
        setActionBtnIndex(0);
        // Refocus the menu item
        requestAnimationFrame(function () {
            var el = itemRefs.current.get(activeNavIndex);
            if (el)
                el.focus();
        });
    }, [activeNavIndex]);
    var handleListKeyDown = useCallback(function (e) {
        var _a;
        if (!openTool || flatNavItems.length === 0)
            return;
        var currentNav = flatNavItems[activeNavIndex];
        console.log('[ManipulativeTool] keydown:', e.key, 'activeNavIndex:', activeNavIndex, 'inActionMode:', inActionModeRef.current, 'currentNav:', ((_a = currentNav === null || currentNav === void 0 ? void 0 : currentNav.item) === null || _a === void 0 ? void 0 : _a.label) || (currentNav === null || currentNav === void 0 ? void 0 : currentNav.item));
        // ─── Action mode: Arrow Left/Right between buttons ───
        if (inActionModeRef.current) {
            switch (e.key) {
                case 'ArrowRight':
                case 'ArrowDown': {
                    e.preventDefault();
                    var buttons = getActionButtons(activeNavIndex);
                    if (buttons.length > 0) {
                        setActionBtnIndex((actionBtnIndex + 1) % buttons.length);
                    }
                    break;
                }
                case 'ArrowLeft':
                case 'ArrowUp': {
                    e.preventDefault();
                    var buttons = getActionButtons(activeNavIndex);
                    if (buttons.length > 0) {
                        setActionBtnIndex((actionBtnIndex - 1 + buttons.length) % buttons.length);
                    }
                    break;
                }
                case 'Enter':
                case ' ': {
                    if (Date.now() - actionModeEnteredAt.current < 300) {
                        // Block the Enter/Space that carried over from entering action mode
                        e.preventDefault();
                        break;
                    }
                    // Let the native button click fire
                    break;
                }
                case 'Escape': {
                    e.preventDefault();
                    e.stopPropagation();
                    exitActionMode();
                    break;
                }
                case 'Tab': {
                    // Exit action mode on Tab to leave menu naturally
                    setInActionMode(false);
                    inActionModeRef.current = false;
                    break;
                }
            }
            return;
        }
        // ─── Menu navigation mode ───
        switch (e.key) {
            case 'ArrowDown':
            case 'ArrowRight': {
                e.preventDefault();
                if ((currentNav === null || currentNav === void 0 ? void 0 : currentNav.isGroup) &&
                    e.key === 'ArrowRight' &&
                    !childOpenList[currentNav.rootIndex]) {
                    // Expand group on ArrowRight
                    setChildOpenList(function (prev) {
                        var next = __spreadArray([], prev, true);
                        next[currentNav.rootIndex] = true;
                        return next;
                    });
                }
                else {
                    // Navigate to next item
                    var next = Math.min(activeNavIndex + 1, flatNavItems.length - 1);
                    focusNavItem(next);
                }
                break;
            }
            case 'ArrowUp':
            case 'ArrowLeft': {
                e.preventDefault();
                if ((currentNav === null || currentNav === void 0 ? void 0 : currentNav.type) === 'child' && e.key === 'ArrowLeft') {
                    // Collapse: move focus to parent group
                    var parentIdx = flatNavItems.findIndex(function (n) { return n.type === 'root' && n.rootIndex === currentNav.rootIndex; });
                    if (parentIdx >= 0)
                        focusNavItem(parentIdx);
                }
                else if ((currentNav === null || currentNav === void 0 ? void 0 : currentNav.isGroup) &&
                    e.key === 'ArrowLeft' &&
                    childOpenList[currentNav.rootIndex]) {
                    // Collapse group on ArrowLeft
                    setChildOpenList(function (prev) {
                        var next = __spreadArray([], prev, true);
                        next[currentNav.rootIndex] = false;
                        return next;
                    });
                }
                else {
                    // Navigate to previous item
                    var prev = Math.max(activeNavIndex - 1, 0);
                    focusNavItem(prev);
                }
                break;
            }
            case 'Enter': {
                e.preventDefault();
                if (currentNav === null || currentNav === void 0 ? void 0 : currentNav.isGroup) {
                    // Toggle expand/collapse for groups
                    setChildOpenList(function (prev) {
                        var next = __spreadArray([], prev, true);
                        next[currentNav.rootIndex] = !next[currentNav.rootIndex];
                        return next;
                    });
                }
                else {
                    // Enter action mode — focus first action button
                    enterActionMode(activeNavIndex, 0);
                }
                break;
            }
            case ' ': {
                e.preventDefault();
                if (currentNav === null || currentNav === void 0 ? void 0 : currentNav.isGroup) {
                    setChildOpenList(function (prev) {
                        var next = __spreadArray([], prev, true);
                        next[currentNav.rootIndex] = !next[currentNav.rootIndex];
                        return next;
                    });
                }
                else {
                    // Same as Enter: enter action mode
                    enterActionMode(activeNavIndex, 0);
                }
                break;
            }
            case 'Home': {
                e.preventDefault();
                focusNavItem(0);
                break;
            }
            case 'End': {
                e.preventDefault();
                focusNavItem(flatNavItems.length - 1);
                break;
            }
            case 'Escape': {
                e.preventDefault();
                setOpenTool(false);
                setChildOpenList(function (prev) { return prev.map(function () { return false; }); });
                setAnnouncement('');
                requestAnimationFrame(function () {
                    setAnnouncement(t('text.manipulativesPanelClosed'));
                });
                break;
            }
        }
    }, [
        openTool,
        flatNavItems,
        activeNavIndex,
        childOpenList,
        focusNavItem,
        inActionMode,
        actionBtnIndex,
        getActionButtons,
        enterActionMode,
        exitActionMode,
        isAdmin,
        viewEditMode,
    ]);
    // Helper: get tabIndex for a nav item's menuitem div
    var getNavTabIndex = useCallback(function (navIndex) {
        if (!openTool)
            return -1;
        return navIndex === activeNavIndex ? 0 : -1;
    }, [openTool, activeNavIndex]);
    // Helper: get tabIndex for an action button inside a nav item
    var getActionBtnTabIndex = useCallback(function (navIndex, btnPosition) {
        if (!openTool)
            return -1;
        // On touch devices, action buttons are always directly focusable
        if (IS_TOUCH_DEVICE)
            return 0;
        if (inActionMode && navIndex === activeNavIndex && btnPosition === actionBtnIndex)
            return 0;
        return -1;
    }, [openTool, inActionMode, activeNavIndex, actionBtnIndex]);
    // Track nav index from flat list for a root item
    var getRootNavIndex = useCallback(function (rootIndex) {
        return flatNavItems.findIndex(function (n) { return n.type === 'root' && n.rootIndex === rootIndex; });
    }, [flatNavItems]);
    // Track nav index from flat list for a child item
    var getChildNavIndex = useCallback(function (rootIndex, childIndex) {
        return flatNavItems.findIndex(function (n) { return n.type === 'child' && n.rootIndex === rootIndex && n.childIndex === childIndex; });
    }, [flatNavItems]);
    return (_jsx("div", { className: "manipulativeTool ".concat(openTool && 'manipulativeToolOpen'), tabIndex: -1, "aria-hidden": maniplulatorComponentVisible, inert: maniplulatorComponentVisible ? true : undefined, 
        /**
         * ! need to check
         */
        onKeyDown: function (e) {
            var _a;
            if (e.key === 'Escape' && openTool) {
                e.preventDefault();
                setOpenTool(false);
                setChildOpenList(function (prev) { return prev.map(function () { return false; }); });
                (_a = scrollbarRef.current) === null || _a === void 0 ? void 0 : _a.scrollToTop();
                setAnnouncement('');
                requestAnimationFrame(function () {
                    setAnnouncement(t('text.manipulativesPanelClosed'));
                });
            }
        }, style: __assign(__assign({}, pos), { '--headerHeight': "".concat(heightVal.headerHeight, "px"), '--zoomPanelHeight': "".concat(heightVal.zoomPanelHeight, "px") }), id: "".concat(displayMode === 'smartBoard' ? 'manipulativeToolSmartBoard' : 'manipulativeTool'), children: btnData && btnData.length > 0 && (_jsxs(_Fragment, { children: [_jsxs("div", { className: "headerContainer", children: [_jsxs("div", { className: "btnWithHeading", children: [_jsx(ButtonComponent, { defaultCSS: "manipulativeToolSettings ".concat(openTool ? 'open' : 'close'), normalCSS: "manipulativeToolSettings", clickHandler: function () {
                                        setChildOpenList(function (prev) { return prev.map(function () { return false; }); });
                                        setOpenTool(function (p) {
                                            var _a;
                                            var newState = !p;
                                            if (!newState) {
                                                (_a = scrollbarRef.current) === null || _a === void 0 ? void 0 : _a.scrollToTop();
                                            }
                                            setAnnouncement('');
                                            requestAnimationFrame(function () {
                                                setAnnouncement(newState
                                                    ? t('text.manipulativesPanelOpened')
                                                    : t('text.manipulativesPanelClosed'));
                                            });
                                            return newState;
                                        });
                                        setTimeout(function () {
                                            customEventHandler.dispatchEvent('toggleRightSidePanel', { isOpen: openTool });
                                        }, 0);
                                    }, onMouseOver: function () { return setHeaderHovered(true); }, onMouseOut: function () { return setHeaderHovered(false); }, ariaLabel: "text.toggleManipulativesList", ariaExpanded: openTool, ariaControls: "manipulatives-menu" }), _jsxs("div", { className: "headingContent", style: { color: headerHovered ? '#ffcf57' : '#ffffff' }, "aria-hidden": "true", children: [_jsx("div", { children: t('text.manipulatives') }), _jsx("img", { src: getImageSrc(headerHovered
                                                ? (_b = (_a = manipulativeBtn === null || manipulativeBtn === void 0 ? void 0 : manipulativeBtn.headerImg) === null || _a === void 0 ? void 0 : _a.imgSrc) === null || _b === void 0 ? void 0 : _b.hover
                                                : (_d = (_c = manipulativeBtn === null || manipulativeBtn === void 0 ? void 0 : manipulativeBtn.headerImg) === null || _c === void 0 ? void 0 : _c.imgSrc) === null || _d === void 0 ? void 0 : _d.normal), alt: "" })] })] }), _jsx("div", { className: "footerModal", children: _jsx("img", { 
                                // src={'./assets/images/popupColorPatch.svg'}
                                src: getImageSrc('./assets/images/shareColourPatches.svg'), tabIndex: -1, alt: "", "aria-hidden": "true" }) })] }), _jsx(CustomScrollbar, { ref: scrollbarRef, className: "verticalList ".concat(openTool && 'displayList', " manipulativeScrollbar"), style: { width: '100%', height: '0px' }, direction: "vertical", tabIndex: -1, ariaHidden: !openTool, inert: !openTool, children: _jsxs("div", { role: openTool && !IS_TOUCH_DEVICE ? 'menu' : undefined, id: "manipulatives-menu", "aria-label": openTool ? t('text.manipulatives') : undefined, onKeyDown: !IS_TOUCH_DEVICE ? handleListKeyDown : undefined, children: [btnData.map(function (item, index) {
                                var _a, _b, _c, _d, _e, _f, _g;
                                var rootNavIdx = getRootNavIndex(index);
                                var isActiveItem = rootNavIdx === activeNavIndex;
                                return (_jsxs(React.Fragment, { children: [_jsx("div", { className: "manipulativBtnHolder ".concat(isActiveItem ? 'activeMenuItem' : '').concat(item.disabled ? ' manipulativBtnHolder--disabled' : ''), ref: function (el) {
                                                if (el && rootNavIdx >= 0)
                                                    itemRefs.current.set(rootNavIdx, el);
                                            }, role: IS_TOUCH_DEVICE ? 'presentation' : 'menuitem', tabIndex: IS_TOUCH_DEVICE ? -1 : getNavTabIndex(rootNavIdx), "aria-label": IS_TOUCH_DEVICE ? undefined : t(item.label), "aria-disabled": item.disabled || undefined, "aria-expanded": !IS_TOUCH_DEVICE && item.type ? childOpenList[index] : undefined, "aria-haspopup": !IS_TOUCH_DEVICE && item.type ? 'menu' : undefined, "aria-controls": !IS_TOUCH_DEVICE && item.type ? "childList_".concat(index) : undefined, onFocus: !IS_TOUCH_DEVICE
                                                ? function () {
                                                    if (!inActionModeRef.current && rootNavIdx >= 0)
                                                        setActiveNavIndex(rootNavIdx);
                                                }
                                                : undefined, children: _jsxs("div", { className: "contentHolder", children: [_jsx(ButtonComponent, { defaultCSS: "manipulativeBtn", normalCSS: "manipulativeBtn", clickHandler: function () { return childBtnClick(index, item); }, disabled: item.disabled, ariaLabel: IS_TOUCH_DEVICE
                                                            ? item.type
                                                                ? t('text.touchToggleGroup', {
                                                                    position: rootNavIdx + 1,
                                                                    name: t(item.label),
                                                                })
                                                                : t('text.touchAddToStage', {
                                                                    position: rootNavIdx + 1,
                                                                    name: t(item.label),
                                                                })
                                                            : item.type
                                                                ? t('text.toggleGroup', { name: t(item.label) })
                                                                : t('text.addToWorkspace', { name: t(item.label) }), tabIndex: getActionBtnTabIndex(rootNavIdx, 0), ariaHidden: !openTool }), _jsx("div", { className: "imgWrapper", children: _jsx("img", { src: getImageSrc(item.icon), alt: t(item.label), className: "iconsImage", "aria-hidden": "true" }) }), _jsx("div", { className: "text", "aria-hidden": "true", children: t(item.label) }), item.type ? (_jsx("img", { src: getImageSrc(childOpenList[index]
                                                            ? (_b = (_a = manipulativeBtn === null || manipulativeBtn === void 0 ? void 0 : manipulativeBtn.arrowBtn) === null || _a === void 0 ? void 0 : _a.imgSrc) === null || _b === void 0 ? void 0 : _b.active
                                                            : (_d = (_c = manipulativeBtn === null || manipulativeBtn === void 0 ? void 0 : manipulativeBtn.arrowBtn) === null || _c === void 0 ? void 0 : _c.imgSrc) === null || _d === void 0 ? void 0 : _d.normal), "aria-hidden": "true", className: "arrowBtn", alt: "" })) : (isAdmin &&
                                                        viewEditMode === 'edit' && (
                                                    // Wrap in inert span when the row is "Coming
                                                    // soon" — combined with `disabled` + ariaHidden
                                                    // on the FlipButton itself, this fully removes
                                                    // the eye toggle from focus, AT, and pointer
                                                    // interaction without hiding it visually.
                                                    _jsx("span", { inert: item.disabled ? true : undefined, "aria-hidden": item.disabled || undefined, children: _jsx(FlipButton, { tool: manipulativeBtn === null || manipulativeBtn === void 0 ? void 0 : manipulativeBtn.showHideBtn, defaultCSS: "eyeBtn", normalCSS: "eyeBtn", onClick: function () {
                                                                manageState(item);
                                                            }, active: (_f = manipulativeBtnState === null || manipulativeBtnState === void 0 ? void 0 : manipulativeBtnState[(_e = item === null || item === void 0 ? void 0 : item.id) !== null && _e !== void 0 ? _e : '']) !== null && _f !== void 0 ? _f : false, showToolTip: true, direction: "left", isParentRelative: true, disabled: item.disabled, tabIndex: item.disabled ? -1 : getActionBtnTabIndex(rootNavIdx, 1), ariaHidden: item.disabled || !openTool, ariaLabel: IS_TOUCH_DEVICE
                                                                ? t('text.touchToggleVisibility', {
                                                                    position: rootNavIdx + 1,
                                                                    name: t(item.label),
                                                                })
                                                                : t('text.toggleVisibility', { name: t(item.label) }) }) })))] }) }), item.childList && item.childList.length > 0 && (_jsx("div", { id: "childList_".concat(index), className: "child-verticalList ".concat(childOpenList[index] ? 'displayList1' : ''), role: IS_TOUCH_DEVICE ? 'group' : 'menu', "aria-label": t(item.label), inert: !childOpenList[index] ? true : undefined, children: ((_g = item.childList) !== null && _g !== void 0 ? _g : []).map(function (childItem, ind) {
                                                var _a, _b;
                                                var childNavIdx = getChildNavIndex(index, ind);
                                                var isActiveChild = childNavIdx === activeNavIndex;
                                                return (_jsx(React.Fragment, { children: _jsx("div", { className: "manipulativBtnHolder ".concat(isActiveChild ? 'activeMenuItem' : '').concat(childItem.disabled ? ' manipulativBtnHolder--disabled' : ''), ref: function (el) {
                                                            if (el && childNavIdx >= 0)
                                                                itemRefs.current.set(childNavIdx, el);
                                                        }, role: IS_TOUCH_DEVICE ? 'presentation' : 'menuitem', tabIndex: IS_TOUCH_DEVICE ? -1 : getNavTabIndex(childNavIdx), "aria-label": IS_TOUCH_DEVICE ? undefined : t(childItem.label), "aria-disabled": childItem.disabled || undefined, onFocus: !IS_TOUCH_DEVICE
                                                            ? function () {
                                                                if (!inActionModeRef.current && childNavIdx >= 0)
                                                                    setActiveNavIndex(childNavIdx);
                                                            }
                                                            : undefined, children: _jsxs("div", { className: "contentHolder", children: [_jsx(ButtonComponent, { defaultCSS: "manipulativeBtn", normalCSS: "manipulativeBtn", clickHandler: function () { return childBtnClick(index, childItem); }, disabled: childItem.disabled, ariaLabel: IS_TOUCH_DEVICE
                                                                        ? t('text.touchAddToStage', {
                                                                            position: childNavIdx + 1,
                                                                            name: t(childItem.label),
                                                                        })
                                                                        : t('text.addToWorkspace', { name: t(childItem.label) }), tabIndex: getActionBtnTabIndex(childNavIdx, 0), ariaHidden: !(openTool && childOpenList[index]) }), _jsx("div", { className: "imgWrapper", children: _jsx("img", { src: getImageSrc(childItem.icon), alt: t(childItem.label), className: "iconsImage", "aria-hidden": "true" }) }), _jsx("div", { className: "text", "aria-hidden": "true", children: t(childItem.label) }), isAdmin && viewEditMode === 'edit' && (_jsx(FlipButton, { tool: manipulativeBtn === null || manipulativeBtn === void 0 ? void 0 : manipulativeBtn.showHideBtn, defaultCSS: "eyeBtn", normalCSS: "eyeBtn", onClick: function () {
                                                                        manageState(childItem);
                                                                    }, active: (_b = manipulativeBtnState === null || manipulativeBtnState === void 0 ? void 0 : manipulativeBtnState[(_a = childItem === null || childItem === void 0 ? void 0 : childItem.id) !== null && _a !== void 0 ? _a : '']) !== null && _b !== void 0 ? _b : false, showToolTip: true, direction: "left", isParentRelative: true, tabIndex: getActionBtnTabIndex(childNavIdx, 1), ariaHidden: !(openTool && childOpenList[index]), ariaLabel: IS_TOUCH_DEVICE
                                                                        ? t('text.touchToggleVisibility', {
                                                                            position: childNavIdx + 1,
                                                                            name: t(childItem.label),
                                                                        })
                                                                        : t('text.toggleVisibility', { name: t(childItem.label) }) }))] }) }) }, "btn".concat(ind)));
                                            }) }))] }, "btn".concat(index)));
                            }), IS_TOUCH_DEVICE && openTool && (_jsx("div", { className: "manipulativBtnHolder", children: _jsx("div", { className: "contentHolder", children: _jsxs("button", { className: "collapsibleCloseBtn", "aria-label": t('text.exitMenu'), onClick: function () { return setOpenTool(false); }, children: [_jsx("span", { "aria-hidden": "true", children: "\u2715" }), _jsx("span", { className: "text", children: t('text.exitMenu') })] }) }) }))] }) }), _jsx("div", { role: "status", "aria-live": "polite", "aria-atomic": "true", className: "srOnly", children: announcement })] })) }));
};
export default ManipulativeTool;
